//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import footerNav from '@/components/footer/footer'
import { Toast } from 'mint-ui'
import { Const } from '@/consts'
import infoApi from '@/api/info'

export default {
    data() {
        return {
            loading: false,
            hasMore: true,
            info: {
                cover: '',
                headerNews: '其实也没什么'
            },

            typeMap: {
                NEWS: 'news',
                TRAINING: 'training',
                EXTRAREADING: 'extrareading'
            },

            data: {
                news: {
                    items: []
                },
                training: {
                    items: []
                },
                course: {
                    items: []
                }
            },

            highlightList: []
        }
    },

    components: {
        footerNav
    },


    created() {
       // this.getHighlighList();
        this.list('NEWS');
        this.list('TRAINING');
        // this.list('EXTRAREADING');
        this.listCourse();
    },

    computed: {
        imgHeight () {
            return (window.innerWidth - 32) * 0.71 + 'px'
        },
        bannerHeight () {
            return (window.innerWidth - 32) * 0.71 + 40 - 0 + 'px'
        }
    },

    methods: {

        list(infoType) {
            infoApi.getInfoList({
                params: {
                    infotype: infoType,
                    pageno: 0,
                    pagesize: 5
                }
            }).then((resp) => {
                const result = resp[Const.RESP_RESULT];
                console.log(result);
                this.data[this.typeMap[infoType]] && (this.data[this.typeMap[infoType]].items = result || []);
                console.log(this.data[this.typeMap[infoType]]);
            }).catch((resp) => {
                // Toast(resp[Const.RESP_MESSAGE] || '获取失败');
                if (resp.statusCode == '200') {
                    Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                }
            });
        },

        listCourse() {
            infoApi.getCourseInfoList({
                params: {
                    pageno: 0,
                    pagesize: 5
                }
            }).then((resp) => {
                const result = resp[Const.RESP_RESULT];
                this.data.course && (this.data.course.items = result || []);
            }).catch((resp) => {
                // Toast(resp[Const.RESP_MESSAGE] || '获取失败');
                if (resp.statusCode == '200') {
                    Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                }
            });
        },

        showInfoDetail(item) {
            this.$router.push({path: '/information/detail', query: {id: item.infoid || ''}});
        },

        getHighlighList() {
            infoApi.getInfoList({
                params: {
                    highlit: 'TRUE',
                    pageno: 0,
                    pagesize: 5
                }
            }).then((resp) => {
                const result = resp[Const.RESP_RESULT];
                this.highlightList = result || [];
            }).catch((resp) => {
                // Toast(resp[Const.RESP_MESSAGE] || '获取失败');
                if (resp.statusCode == '200') {
                    Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败');
                }
            });
        },

        showMore(infoType) {
            this.$router.push({
                path: '/information/more',
                query: {
                    type: this.typeMap[infoType]
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/view/information/information.vue